export default "__VITE_ASSET__LcVRBmSj__"